const Phone = () => {
  return (
    <svg
      className='list-options__svg'
      width='17'
      height='17'
      viewBox='0 0 17 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.20508 0.5H4.20508C3.65279 0.5 3.20508 0.947754 3.20508 1.5V15.5C3.20508 16.0522 3.65279 16.5 4.20508 16.5H12.2051C12.7574 16.5 13.2051 16.0522 13.2051 15.5V1.5C13.2051 0.947754 12.7574 0.5 12.2051 0.5H11.2051C11.2051 1.05225 10.7574 1.5 10.2051 1.5H6.20508C5.65279 1.5 5.20508 1.05225 5.20508 0.5ZM4.70508 14.5C4.42894 14.5 4.20508 14.7239 4.20508 15C4.20508 15.2761 4.42894 15.5 4.70508 15.5H11.7051C11.9812 15.5 12.2051 15.2761 12.2051 15C12.2051 14.7239 11.9812 14.5 11.7051 14.5H4.70508ZM5.20508 5C5.20508 4.72388 5.42894 4.5 5.70508 4.5H10.7051C10.9812 4.5 11.2051 4.72388 11.2051 5C11.2051 5.27612 10.9812 5.5 10.7051 5.5H5.70508C5.42894 5.5 5.20508 5.27612 5.20508 5ZM5.70508 6.5C5.42894 6.5 5.20508 6.72388 5.20508 7C5.20508 7.27612 5.42894 7.5 5.70508 7.5H10.7051C10.9812 7.5 11.2051 7.27612 11.2051 7C11.2051 6.72388 10.9812 6.5 10.7051 6.5H5.70508ZM6.20508 9C6.20508 8.72388 6.42894 8.5 6.70508 8.5H9.70508C9.98122 8.5 10.2051 8.72388 10.2051 9C10.2051 9.27612 9.98122 9.5 9.70508 9.5H6.70508C6.42894 9.5 6.20508 9.27612 6.20508 9Z'
        fill='white'
      />
    </svg>
  );
};
export default Phone;
